/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInviteReplyExtra,
    JsonInviteReplyExtraFromJSON,
    JsonInviteReplyExtraFromJSONTyped,
    JsonInviteReplyExtraToJSON,
} from './JsonInviteReplyExtra';

/**
 * 
 * @export
 * @interface ApiResultOfJsonInviteReplyExtra
 */
export interface ApiResultOfJsonInviteReplyExtra {
    /**
     * 
     * @type {JsonInviteReplyExtra}
     * @memberof ApiResultOfJsonInviteReplyExtra
     */
    data?: JsonInviteReplyExtra;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyExtra
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonInviteReplyExtra
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyExtra
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyExtra
     */
    result?: ApiResultOfJsonInviteReplyExtraResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonInviteReplyExtraResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonInviteReplyExtraFromJSON(json: any): ApiResultOfJsonInviteReplyExtra {
    return ApiResultOfJsonInviteReplyExtraFromJSONTyped(json, false);
}

export function ApiResultOfJsonInviteReplyExtraFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonInviteReplyExtra {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonInviteReplyExtraFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonInviteReplyExtraToJSON(value?: ApiResultOfJsonInviteReplyExtra | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonInviteReplyExtraToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

